import React, { useEffect, useState } from "react";
import { parse } from "query-string";
import { useLocation } from "react-router";
import InputButton from "components/buttons/InputButton";

const SuggestFeature = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  document.title = "Suggest a feature you want | Atrable";

  const [suggestion, setSuggestion] = useState("");

  const onChange = (event) => {
    setSuggestion(event.value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    //submit the feedback
  };

  return (
    <div style={{ minHeight: "100vh", textAlign: "center" }}>
      <div
        style={{
          backgroundColor: "whitesmoke",
          textAlign: "center",
          width: "75%",
          maxWidth: "800px",
          minWidth: "200px",
          margin: "auto",
          padding: "30px",
          borderRadius: "15px",
          marginTop: "50px",
        }}
      >
        <h1 style={{ marginBottom: 90 }}>Suggest a Feature</h1>
        <form onSubmit={onSubmit}>
          <textarea
            style={{
              height: 100,
              width: "90%",
              border: "none",
              borderRadius: 15,
              padding: 15,
              fontSize: 15,
              fontFamily: "Montserrat",
              color: "black",
              fontWeight: 700,
            }}
            placeholder="What do you want to suggest?"
            value={suggestion}
            required
            onChange={onChange}
          ></textarea>
          <div style={{ marginTop: "15px", marginBottom: "30px" }}>
            <InputButton
              value="Suggest"
              width="calc(90% + 30px)"
              maxWidth="750px"
              minWidth="100px"
              backgroundColor="#1877f3"
              color="white"
            />
          </div>
        </form>
      </div>
      <div style={{ height: 90 }} />
    </div>
  );
};

export default SuggestFeature;
